export enum KeystoneSignEnum {
  MSG = 'msg',
  PSBT = 'psbt',
  BIP322_SIMPLE = 'bip322-simple',
  COSMOS_DIRECT = 'cosmos-direct',
  COSMOS_ARBITRARY = 'cosmos-arbitrary',
}
